<template>
    <div>
        <Loading :value="loading" ></Loading>

                    <v-card color="blue-grey darken-1"
                            class="white--text elevation-5">
                        <v-layout>
                            <v-flex xs4 pt-2 pl-2 class="text-xs-center">
                                <v-avatar
                                        size="100px"
                                        color="grey lighten-4"
                                        class="mb-1"
                                >
                                    <img src="/static/avatar-conducteur.png" alt="avatar">
                                </v-avatar>
                            </v-flex>
                            <v-flex xs8>
                                <v-card-title primary-title>
                                    <div>
                                        <div class="subheading">{{contrat.userContrat}}</div>
                                        <div class="body-1">{{contrat.poste}}</div>
                                        <div class="body-1">Echéance: {{contrat.dateEcheance}}</div>
                                        <div class="body-1">ID-CONT {{contrat.idContrat}}</div>
                                        <div class="caption" >
                                            <v-chip label  color="blue darken-4" text-color="white">{{contrat.libTypeContrat}}</v-chip>
                                        </div>
                                    </div>
                                </v-card-title>
                            </v-flex>
                        </v-layout>
                        <v-divider light></v-divider>
                        <v-card-actions class="pa-3">
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <v-btn class="mr-2" v-if="contrat.etat == 2"  @click="showRenouvContrat()"  dark slot="activator"  icon color="orange">
                                    <v-icon>autorenew</v-icon>
                                </v-btn>
                                renoulever
                            </v-tooltip>

                            <v-tooltip bottom>
                                <v-btn class="mr-2" v-if="contrat.etat == 0" dark slot="activator"  @click="showAnnuleContrat(contrat)" icon color="red">
                                    <v-icon>close</v-icon>
                                </v-btn>
                                annuler
                            </v-tooltip>

                            <v-tooltip bottom>
                                <v-btn @click="showDetailEmpl(contrat.userIdContrat)"  dark slot="activator" icon color="primary">
                                    <v-icon>visibility</v-icon>
                                </v-btn>
                                Détail
                            </v-tooltip>
                        </v-card-actions>
                    </v-card>


        <!--DIALOG ANNULER CONTRAT-->
        <v-dialog
                v-model="dialogAnnuleCont"
                max-width="550"
        >
            <v-card>
                <v-card-title class="headline">

                    <el-alert
                            :title="'Voulez-vous annuler le contrat ID-' +contrat.idContrat+ ' de l\'employé '+contrat.userContrat+' ? '"
                            type="warning"
                            :closable="false"
                            show-icon>
                    </el-alert>
                </v-card-title>
                <v-card-text>
                    <el-input :rows="4" placeholder="Motif d'annulation" type="textarea" v-model="descAnnule"></el-input>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="green darken-1"
                            flat="flat"
                            @click="dialogAnnuleCont = false"
                    >
                        Non
                    </v-btn>

                    <v-btn
                            color="red darken-1"
                            flat="flat"
                            :disabled="descAnnule == '' "
                            @click="submitEtatCont(4)"
                    >
                        Oui
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--DIALOG renouveler CONTRAT-->
        <v-dialog
                v-model="dialogRenouvCont"
                max-width="550"
        >
            <v-card>
                <v-card-title class="headline">

                    <el-alert
                            :title="'Voulez-vous renouveler le contrat ID-' +contrat.idContrat+ ' de l\'employé '+contrat.userContrat+' ? '"
                            type="warning"
                            :closable="false"
                            show-icon>
                    </el-alert>
                </v-card-title>
                <v-card-text>
                    <el-form label-position="top" ref="formValidite"  :model="formValidite" >
                        <el-row type="flex" :gutter="20">
                            <el-col :span="24">
                                <div class="block">
                                    <el-form-item label="Période de validité" >
                                        <el-date-picker
                                                v-model="formValidite.datedbtFin"
                                                style="width:100%"
                                                type="daterange"
                                                format="dd-MM-yyyy"
                                                value-format="yyyy-MM-dd"
                                                range-separator="à"
                                                start-placeholder="Date de début"
                                                end-placeholder="Date de fin">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="grey darken-1"
                            flat="flat"
                            @click="dialogRenouvCont = false"
                    >
                        Non
                    </v-btn>

                    <v-btn
                            color="green darken-1"
                            class="white--text"
                            :disabled="formValidite.datedbtFin == null"
                            @click="submitRenewContrat()"
                    >
                        Renouveler
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>

</template>

<script>
    import Loading from '@/components/Loading';
    export default {
        components: {Loading},
        name: "modelCarteContrat",
        props: {
            contrat: {
                type: Object
            }
        },
        data(){
            return {
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
                loading: false,


                dialogAnnuleCont: false,
                dialogRenouvCont: false,
                descAnnule: "",
                formValidite: {
                    datedbtFin: ""
                }

            }
        },
        methods:{
            showDetailEmpl(idEmp){
                this.$emit("detailEmpl",idEmp);
            },
            showAnnuleContrat(){
                this.dialogAnnuleCont = true
            },
            showRenouvContrat(){
                this.dialogRenouvCont = true
            },
            submitRenewContrat(){
                this.loading = true;
                let urlVerif = this.domaine + 'rh/verification/contrat/employe/'+this.contrat.userIdContrat;
                let dataVerif = {
                    dateDbt: this.formValidite.datedbtFin[0],
                    dateFin: this.formValidite.datedbtFin[1],
                    typeContrat: this.contrat.typeContrat
                };

                //Verifier si le contrat peut etre renouveler
                this.$http.get(urlVerif,{params: dataVerif}).then(resp=>{
                    this.loading = false;
                    if(resp.body.code == 0) //le contrat ne peut etre creer
                    {
                        this.dialogRenouvCont = false,
                            this.$alert(resp.body.message, 'Validation champs date', {
                                confirmButtonText: 'OK',
                            });
                        //changer etat du contrat a expire
                        this.submitEtatCont(3)
                        return;
                    }
                    //le contrat ne peut etre creer
                    this.submitEtatCont(resp.body.etatContrat)
                }, error =>{
                    this.loading = false;
                    this.formContrat.dateFin = null;
                    this.dateInvalide = true;
                    this.$message.error("Une erreur sest produite lors de la validation des champs dates")

                });


            },
            submitEtatCont(etat){
                this.loading = true;
                let url = this.domaine+"rh/contrat/"+this.contrat.idContrat+"/changeEtat";


                let data = new FormData();
                data.append("dateValidite",this.formValidite.datedbtFin)
                data.append("etat", etat);
                data.append("userId", this.user.id);
                data.append("motif", this.descAnnule)
                this.$http.post(url, data).then(resp =>{
                    this.loading = false;
                    this.dialogAnnuleCont = false;
                    this.dialogRenouvCont = false;
                    this.formValidite.datedbtFin = null;
                    this.$emit("contAnnule")
                    this.successNotif(resp.body.message);
                }, error =>{
                    this.loading = false;
                    this.dialogAnnuleCont = false;
                    this.$message.error("Echec lors de l'annulation du  contrat")
                });
            },

            successNotif(mess = ""){
                this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: mess,
                    duration: 10000,
                    type: 'success',
                    position: 'top-center'
                })
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/resourceHumaine/modelCarteContrat.vue